<template>
  <div>
    <b-autocomplete
      v-model="reportId"
      :items="$directory.get('reportList')"
      placeholder="Оберіть зі списку"
      item-value="id"
      item-title="period"
      label="Звітній період"
      :loading="$loading.isLoading('reportList')"
      :error-messages="getErrorMessages(v$.reportId)"
      @blur="v$.reportId.$touch()">
    </b-autocomplete>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { getErrorMessages } from 'best-modules/utils'
import { fillDirectory } from '@/directory'

export default {
  name: 'ReportSelect',
  methods: { getErrorMessages },
  setup() {
    fillDirectory('reportList')

    const reportId = ref<number>(null)

    const rules = { reportId: { required } }
    const v$ = useVuelidate(rules, { reportId })

    const submit = () => {
      return Promise.resolve({ reportId: reportId.value })
    }

    return { reportId, v$, submit }
  },
}
</script>

<style scoped lang="scss"></style>
